import styled from "styled-components";

export const HiddenPlayerWrapper = styled.div`
  width: 100%;
  height: 1px;
  opacity: 0;
  pointer-events: none;
  overflow: hidden;
  position: absolute;
`;

export const WarningText = styled.p`
  color: #ff6464;
  font-size: 12px;
  margin-top: 8px;
`;
